// Excel serial date number to ISO date string (e.g. "40386" -> "2010-07-27").
// Excel's epoch is 1900-01-01 but it treats 1900 as a leap year, so its real
// anchor is 1899-12-30 with one-day-per-unit math.
export function excelSerialToISODate(serial: string) {
  const num = Number(serial);
  if (!Number.isFinite(num) || num < 1) return undefined;
  const excelEpoch = new Date(Date.UTC(1899, 11, 30));
  const date = new Date(excelEpoch.getTime() + num * 86400000);
  return date.toISOString().split('T')[0];
}
